import React, { useEffect } from "react";
import {
  Typography,
  Row,
  Col,
  Card,
  Divider,
  Image,
  Form,
  Input,
  Button,
  Alert,
} from "antd";
import {
  PhoneOutlined,
  MailOutlined,
  EnvironmentOutlined,
  CompassOutlined,
} from "@ant-design/icons";
import axios from "axios";

const { Title, Paragraph } = Typography;

const ContactUs = () => {
  const [form] = Form.useForm();
  const [formSuccessMessage, setFormSuccessMessage] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  useEffect(() => {
    document.title = "JOJ | Contact Us";
    logUserActivity({ detail: "" });
  }, []);

  const logUserActivity = async ({ detail }) => {
    const tokenString = localStorage.getItem("token");

    try {
      const jsondata = JSON.stringify({
        ScreenID: "4",
        DetailID: "0",
        Detail: detail,
      });

      let config = {
        method: "post",
        url: global.config.APIURL.BaseURL + "api/UserActivity/InsertActivity",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tokenString,
        },
        data: jsondata,
      };

      axios
        .request(config)
        .then((response) => {})
        .catch((error) => {});
    } catch (err) {}
  };

  const onFinish = (values) => {
    setIsLoading(true);
    setFormSuccessMessage("");
    // Handle form submission logic here
    try {
      setFormSuccessMessage("");
      const listData = {
        Name: values.name,
        ContactNo: values.mobile,
        Message: values.message,
      };

      let config = {
        method: "post",

        url:
          global.config.APIURL.BaseURL + "api/ContactUs/InsertContactUsRequest",
        headers: {
          "Content-Type": "application/json",
        },
        data: listData,
      };

      axios
        .request(config)
        .then((response) => {
          logUserActivity({ detail: "Contact-Us-Requested" });
          setFormSuccessMessage("Request submitted successfully!");
          form.resetFields();
        })
        .catch((error) => {});
    } catch (err) {}
    setIsLoading(false);
  };

  return (
    <div
      style={{
        background: "linear-gradient(to right, #fbc2eb, #a6c1ee)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 24,
        borderRadius: 16,
      }}
    >
      <Card
        style={{
          maxWidth: 800,
          width: "100%",
          textAlign: "center",
          borderRadius: 16,
          boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
          background: "rgba(255, 255, 255, 0.95)",
          alignItems: "center",
        }}
      >
        {/* Banner Image */}
        <center>
          <Card
            style={{
              backgroundColor: "#2f3543",
              width: "70%",
            }}
          >
            <Image
              src="https://thejoj.com/images/JOJColorLogo.png"
              alt="Contact banner"
              style={{
                width: "100%",
                maxHeight: 400,
                objectFit: "cover",
                borderRadius: 12,
              }}
              preview={false}
            />
          </Card>
        </center>

        {/* Title and Paragraph */}
        <Typography style={{ marginTop: 32 }}>
          <Title level={2} style={{ textAlign: "center" }}>
            Contact Us
          </Title>
          <Paragraph
            style={{
              textAlign: "center",
              fontSize: 16,
              maxWidth: 800,
              margin: "auto",
            }}
          >
            We’re here to help! Whether you have questions about products,
            orders, or anything else, feel free to reach out. We'd love to hear
            from you.
          </Paragraph>
        </Typography>

        <Divider />

        {/* Form and Contact Details */}
        <Row gutter={[24, 24]}>
          {/* Contact Form */}
          <Col xs={24} md={14}>
            <Card
              title="Send us a Message"
              bordered={false}
              style={{ borderRadius: 12 }}
            >
              <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                requiredMark={false}
              >
                <Form.Item
                  name="name"
                  label="Name"
                  rules={[
                    { required: true, message: "Please enter your name" },
                  ]}
                >
                  <Input placeholder="Your Name" />
                </Form.Item>

                <Form.Item
                  name="mobile"
                  label="Mobile Number"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your mobile number",
                    },
                    {
                      pattern: /^[0-9]{10}$/,
                      message: "Enter a valid 10-digit number",
                    },
                  ]}
                >
                  <Input placeholder="Mobile Number" />
                </Form.Item>

                <Form.Item
                  name="message"
                  label="Message"
                  rules={[
                    { required: true, message: "Please enter your message" },
                  ]}
                >
                  <Input.TextArea placeholder="Your message..." rows={4} />
                </Form.Item>

                <Form.Item>
                  <Button type="primary" htmlType="submit" loading={isLoading}>
                    Submit
                  </Button>
                </Form.Item>

                {formSuccessMessage ? (
                  <div
                    style={{
                      textAlign: "left",
                      marginBottom: 16,
                      marginTop: 16,
                    }}
                  >
                    <Alert message={formSuccessMessage} type="success" />
                  </div>
                ) : null}
              </Form>
            </Card>
          </Col>

          {/* Contact Info */}
          <Col xs={24} md={10}>
            <Card
              title="Get in Touch"
              bordered={false}
              style={{ borderRadius: 12 }}
            >
              <Paragraph>
                <PhoneOutlined /> <strong>Phone:</strong> <br />
                <a href="tel:8000002808">80000 02808</a>
              </Paragraph>

              <Paragraph>
                <MailOutlined /> <strong>Email:</strong> <br />
                <a href="mailto:admin@jewelsofjoy.in">admin@jewelsofjoy.in</a>
              </Paragraph>

              <Paragraph>
                <EnvironmentOutlined /> <strong>Address:</strong> <br />
                Shree Ranchhod Nagar, Bh. Sant Kabir Road, Rajkot, Gujarat
                <br />
                <a
                  href="https://maps.app.goo.gl/KQqdjp3pviaJRwTPA"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#1677ff",
                    fontWeight: 500,
                    display: "inline-block",
                    marginTop: 6,
                  }}
                >
                  <CompassOutlined style={{ marginRight: 6 }} />
                  Show On Map
                </a>
              </Paragraph>
            </Card>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default ContactUs;
